import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearError, showError, showSuccess } from '../snackbars/snackbars-actions';
import DashboardSummaryView from './dashboard-summary-view';
import Api from '../../library/api';
import { logout } from '../auth/auth-actions';

class DashboardSummary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  setLoading = () => this.setState({loading: true});

  expireSession = () => {
    Api.post('token-test') // should force a CSRF mismatch error
  };

  render() {
    return <DashboardSummaryView {...this.props} setLoading={this.setLoading} loading={this.state.loading} expireSession={this.expireSession}/>
  }

}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage
});

const mapDispatchToProps = {
  clearError: clearError,
  showError: showError,
  showSuccess: showSuccess,
  logout: logout
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSummary);



// WEBPACK FOOTER //
// ./src/components/dashboard-summary/dashboard-summary.js